<div class="card loading_card">
  <div class="card-img"></div>
  <div class="card-body">
    <div class="date">
      <p>xxxx xxx xxxx</p>
      <p>xxxx  xxx xxx</p>
    </div>
    <h3>xxxxxxxxxxxxx</h3>
    <p class="desc" >xxxxxxxxxxxxx xxxxxxxxxxxxx </p>
  </div>
</div>
